/* Navigation only. Purchase state, product forms and the native sticky bar remain authoritative. */
(() => {
  if (window.ggLongformNavigationReady) return;
  window.ggLongformNavigationReady = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-ggl-return]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const purchase = document.querySelector('.product-information .product-details');
    if (!purchase) return;
    event.preventDefault();
    const choice = purchase.querySelector('variant-picker input:checked') || purchase.querySelector('variant-picker select') || purchase.querySelector('button[name="add"]');
    const target = choice?.closest('fieldset') || choice || purchase;
    target.scrollIntoView({ block: 'center', behavior: 'auto' });
    if (choice) choice.focus({ preventScroll: true });
  });
})();
